<template>
  <div class="position-relative">
    <section class="section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-7 text-center">
              <h2 class="text-white display-1">Seja bem-vindo,<span>colecionador!</span></h2>
                <p class="lead text-white mt-4 mb-5">Conheça meu acervo pessoal, reunido ao longo de anos de garimpagem em sebos, exibições da televisão, intercâmbios e aquisições.</p>
              <div class="btn-wrapper mb-5">
                <movie-search-form></movie-search-form>
                <base-button type="primary" size="lg" icon="fa fa-film" @click="$router.push('novidades')">
                  Últimos Títulos Dublados
                </base-button>
              </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  </div>
</template>
<script>
import MovieSearchForm from '@/layout/components/Catalog/MovieSearchForm';
export default {
    components: {
      MovieSearchForm
    },
};
</script>
<style>
</style>
